module.exports = __webpack_public_path__ + "static/media/Tube.a6076972.svg";